import { type GetCustomMetrics_me_customMetrics } from "@/nb-api-graphql-generated";

import { type SalesMetricV2 } from "../types";

export function makeCustomMetric({
  customMetric,
}: {
  customMetric: GetCustomMetrics_me_customMetrics;
}): SalesMetricV2 {
  const id = `customMetric:${customMetric.id}`;

  return {
    id,
    name: customMetric.name,
    fullName: customMetric.name,
    description: customMetric.description,
    category: "northbeam",
    positiveTrend: customMetric.is_negative_trend_good ? "down" : "up",
    format: customMetric.data_type,
    getValue(metrics) {
      return metrics.customMetrics?.[customMetric.id];
    },
    isCustom: true,
    customAccountingMode: customMetric.accounting_mode as "accrual" | "cash",
  };
}
